import { Component } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfigurazioneStagione } from '../../../shared/interface';

@Component({
  selector: 'app-stagione-backoffice',
  templateUrl: './stagione-backoffice.component.html',
  styleUrl: './stagione-backoffice.component.css'
})
export class StagioneBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router) { }

  configurazione?: ConfigurazioneStagione

  formStagione!: FormGroup;
  loading = false;

  ngOnInit(): void {

    this.formStagione = new FormGroup({
      titolo: new FormControl(null, Validators.required),
      descrizione: new FormControl(null),
      button: new FormControl(null),
      link: new FormControl(null),
      button_2: new FormControl(null),
      link_2: new FormControl(null),
      button_3: new FormControl(null),
      link_3: new FormControl(null),
      button_4: new FormControl(null),
      link_4: new FormControl(null),
      img_1: new FormControl(null, Validators.required),
      img_2: new FormControl(null, Validators.required),
      img_3: new FormControl(null, Validators.required),
      programma: new FormControl(null),
    })

    this.apiService.getConfigurazioneStagione().subscribe({
      next: (data) => this.configurazione = data,
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        this.formStagione.patchValue({
          titolo: this.configurazione?.titolo,
          descrizione: this.configurazione?.descrizione,
          button: this.configurazione?.button,
          link: this.configurazione?.link,
          button_2: this.configurazione?.button_2,
          link_2: this.configurazione?.link_2,
          button_3: this.configurazione?.button_3,
          link_3: this.configurazione?.link_3,
          button_4: this.configurazione?.button_4,
          link_4: this.configurazione?.link_4,
          img_1: this.configurazione?.img_1,
          img_2: this.configurazione?.img_2,
          img_3: this.configurazione?.img_3,
        })

      },
    })

  }

  onSubmit() {
    if (this.loading) return;

    const stagione = new FormData();
    stagione.append('titolo', this.formStagione.get('titolo')?.value || '');
    stagione.append('descrizione', this.formStagione.get('descrizione')?.value || '');
    stagione.append('button', this.formStagione.get('button')?.value || '');
    stagione.append('link', this.formStagione.get('link')?.value || '');
    stagione.append('button_2', this.formStagione.get('button_2')?.value || '');
    stagione.append('link_2', this.formStagione.get('link_2')?.value || '');
    stagione.append('button_3', this.formStagione.get('button_3')?.value || '');
    stagione.append('link_3', this.formStagione.get('link_3')?.value || '');
    stagione.append('button_4', this.formStagione.get('button_4')?.value || '');
    stagione.append('link_4', this.formStagione.get('link_4')?.value || '');
    stagione.append('img_1', this.formStagione.get('img_1')?.value || '');
    stagione.append('img_2', this.formStagione.get('img_2')?.value || '');
    stagione.append('img_3', this.formStagione.get('img_3')?.value || '');
    stagione.append('programma', this.formStagione.get('programma')?.value || '');

    this.loading = true;

    const req = JSON.stringify(this.configurazione) != '{}'
      ? this.apiService.updateConfigurazioneStagione(stagione)
      : this.apiService.addConfigurazioneStagione(stagione);

    const okMsg = JSON.stringify(this.configurazione) != '{}'
      ? 'Dati modificati con successo!'
      : 'Dati caricati con successo!';

    req.subscribe({
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err.error.message.message);
      },
      complete: () => {
        this.apiService.message('success', 'Successo', okMsg);
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/backoffice/stagione']);
        });
      },
    });
  }

}
